import React, { Component } from "react";
import PropTypes from "prop-types";
import validator from "email-validator";
import { Loader } from "semantic-ui-react";
import { confirmAlert } from "react-confirm-alert";

class PasswordReminder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      error: false,
      submitted: false
    };
  }

  PasswordReminder(e) {
    e.preventDefault();

    let email = this.state.email.trim();

    if (this.props.isConnected) {
      this.setState({ submitted: true });

      if (validator.validate(email)) {
        this.props.onPasswordReminder(email);
      } else {
        this.setState({ error: true });
      }
    }
  }

  renderError() {
    if (!this.props.isConnected) {
      return null;
    }

    if (
      (this.state.error && !this.state.submitted) ||
      (this.state.submitted && !validator.validate(this.state.email))
    ) {
      const options = {
        message: "Please enter a valid email address",
        buttons: [
          {
            label: "OK"
          }
        ]
      };

      this.setState({ submitted: false, error: false });

      return confirmAlert(options);
    }

    if (this.props.status === 2 && this.state.submitted) {
      const options = {
        message: "Email address not found",
        buttons: [
          {
            label: "OK"
          }
        ]
      };
      this.setState({ submitted: false });

      return confirmAlert(options);
    }

    return <div></div>;
  }

  GoBack() {
    this.props.onBack();
  }

  updateInputValue(e) {
    var change = {};
    change[e.target.id] = e.target.value;
    this.setState(change);
  }

  renderPasswordReminder() {
    if (this.props.status === 3) {
      return (
        <div
          style={{
            display: "flex",
            marginTop: 100,
            width: "600px",
            alignItems: "center"
          }}
        >
          <Loader
            active
            className="ui large home active text centered inline loader"
            size="large"
            style={{ color: "#fff" }}
            inline="centered"
          ></Loader>
        </div>
      );
    }

    if (
      this.props.status === 0 ||
      this.props.status === 2 ||
      this.props.status === 3
    ) {
      return (
        <form
          onSubmit={this.PasswordReminder.bind(this)}
          style={{ fontFamily: "Arial" }}
        >
          <br />
          {this.renderError()}
          <p
            style={{
              display: "block",
              marginRight: 30,
              fontFamily: "'Open Sans', sans-serif",
              fontSize: 13,
              color: "white"
            }}
          >
            Enter the e-mail address associated with your account. Click submit
            to have your password e-mailed to you.
          </p>
          <input
            class="lInput"
            value={this.props.isConnected ? this.state.email : ""}
            placeholder={
              this.props.isConnected
                ? "E-Mail Address"
                : "Connection is offline"
            }
            style={{
              width: "100%",
              height: 48,
              padding: "2px 10px",
              lineHeight: "1.65em",
              textIndent: ".571em",
              outline: 0,
              color: "black",
              borderRadius: 6,
              background: "#e8f0fe"
            }}
            id="email"
            type="text"
            name="email"
            required=""
            onChange={e => this.updateInputValue(e)}
            validationmessage="Please enter Login"
          />

          <br />
          <div style={{ marginTop: 20 }}>
            <input
              id="login_button"
              class="lLogin"
              onClick={this.PasswordReminder.bind(this)}
              type="submit"
              value="Continue"
              style={{
                height: 44,
                borderRadius: 6,
                cursor: "pointer",
                border: "2px solid #dcecf7",
                padding: "10px 20px",
                minWidth: "160px",
                color: "#fff"
              }}
            ></input>
          </div>
        </form>
      );
    }

    if (this.props.status === 1) {
      return (
        <div>
          <br />
          <p
            style={{
              display: "block",
              marginRight: 30,
              fontFamily: "'Open Sans', sans-serif",
              fontSize: 13,
              color: "white"
            }}
          >
            An email has been sent to you.
          </p>
          <div style={{ marginTop: 20 }}>
            <input
              id="login_button"
              class="lLogin"
              onClick={this.GoBack.bind(this)}
              type="button"
              value="Back To Login"
              style={{
                height: 44,
                borderRadius: 6,
                cursor: "pointer",
                border: "2px solid #dcecf7",
                padding: "10px 20px",
                minWidth: "160px",
                color: "#fff"
              }}
            ></input>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div style={{ width: "100%" }} className="login">
        {this.renderPasswordReminder()}
      </div>
    );
  }
}

PasswordReminder.propTypes = {};

export default PasswordReminder;



// WEBPACK FOOTER //
// ./src/components/PasswordReminder/index.js